export default __webpack_public_path__ + "static/education-survey-builder-faa076a67100acbf0242f7c885942fd1.gif";